// import 'jquery-validation'
import 'jquery-mask-plugin'

export default {
  init() {
    // console.log('DOPASUJ INIT');

    // KONFIGURATOR
    var plec;
    var wiek;
    var wzrost;
    var waga;
    var aktywnosc;
    var cel;
    var cpm;
    var przedzial;
    var nazwa;
    var kalorycznosc1;

    $('.wiek').mask('00');
    $('.wzrost').mask('000');
    $('.waga').mask('000');

    if ($('#konfigurator').length) {
      // console.log('Kalkulator INIT');
      kalkulatorInit()
    }

    function kalkulatorInit()
    {
      $('#konfigurator-wynik-box').removeClass('active');
      $('#kontakt-info-container').removeClass('active');
      $('#cta-btn').hide();
      $('.plec-btn').removeClass('active');

      $('.wiek-col').removeClass('active');
      $('.wzrost-col').removeClass('active');
      $('.waga-col').removeClass('active');

      $('.aktywnosc-row').removeClass('active');
      $('.cel-row').removeClass('active');

      $('.wiek').removeClass('active').addClass('disabled').prop('disabled', true).val('');
      $('.wzrost').removeClass('active').addClass('disabled').prop('disabled', true).val('');
      $('.waga').removeClass('active').addClass('disabled').prop('disabled', true).val('');
      $('.aktywnosc-btn').removeClass('active').addClass('disabled').prop('disabled', true);
      $('.cel-btn').removeClass('active').addClass('disabled').prop('disabled', true);
    }

    function calcCPM()
    {
      if ( plec === 'kobieta') {
        // console.log('CPM - licze kobiete');
        cpm = aktywnosc * ((665.09 + (9.56 * waga)) + (1.85 * wzrost) - (4.67 * wiek));
        // console.log(cpm);
      } else if ( plec === 'mezczyzna') {
        // console.log('CPM - licze mezczyzne');
        cpm = aktywnosc * ((66.47 + (13.75 * waga)) + (5 * wzrost) - (6.75 * wiek));
        // console.log(cpm);
      }
    }

    $('.plec-btn').click(function() {
      kalkulatorInit();
      plec = $(this).attr('data-plec');
      wiek = undefined;
      wzrost = undefined;
      waga = undefined;
      aktywnosc = undefined;
      cel = undefined;
      // console.log(plec);
      // console.log(wiek);
      // console.log(wzrost);
      // console.log(waga);
      // console.log(aktywnosc);
      // console.log(cel);
      $(this).addClass('active');
      $('.wiek-col').addClass('active');
      $('#wiek').removeClass('disabled').prop('disabled', false);
      $('#wiek').focus();
    });

    $('#wiek').keyup(function () {
      if( $(this).val().length == 2 ) {
        // console.log('trigger wiek');
        wiek = $(this).val();
        $('.wzrost-col').addClass('active');
        $('#wzrost').removeClass('disabled').prop('disabled', false);
        $('#wzrost').focus();
      }
      if ( (cel !== undefined) && (aktywnosc !== undefined) ) {
        dopasujDiete()
      }
    });

    $('#wzrost').keyup(function () {
      if( $(this).val().length > 2 ) {
        // console.log('trigger wzrost');
        wzrost = $(this).val();
        $('.waga-col').addClass('active');
        $('#waga').removeClass('disabled').prop('disabled', false);
        $('#waga').focus();
      }
      if ( (cel !== undefined) && (aktywnosc !== undefined) ) {
        dopasujDiete()
      }
    });

    $('#waga').keyup(function () {
      if( $(this).val().length >= 2 ) {
        // console.log('trigger waga');
        waga = $(this).val();
        $('.aktywnosc-row').addClass('active');
        $('.aktywnosc-btn').removeClass('disabled').prop('disabled', false);
      }
      if ( (cel !== undefined) && (aktywnosc !== undefined) ) {
        dopasujDiete()
      }
    });

    $('.aktywnosc-btn').click(function() {
      aktywnosc = $(this).attr('data-aktywnosc');
      // console.log(plec);
      // console.log(wiek);
      // console.log(wzrost);
      // console.log(waga);
      // console.log(aktywnosc);
      // console.log(cel);
      $('.aktywnosc-btn').removeClass('active');
      $(this).addClass('active');
      $('.cel-row').addClass('active');
      $('.cel-btn').removeClass('disabled').prop('disabled', false);
      if ( cel !== undefined ) {
        dopasujDiete()
      }
    });

    $('.cel-btn').click(function() {
      cel = $(this).attr('data-cel');
      // console.log(plec);
      // console.log(wiek);
      // console.log(wzrost);
      // console.log(waga);
      // console.log(aktywnosc);
      // console.log(cel);
      $('.cel-btn').removeClass('active');
      $('.cel-btn').removeClass('disabled').prop('disabled', false);
      $(this).addClass('active');
      dopasujDiete()
    });

    function dopasujDiete()
    {
      // console.log('DOPASOWUJE KALORYKE');
      calcCPM();
      if ((cpm > 1000) && (cpm <= 1099)) {
        przedzial = '1000-1099';
      } else if ((cpm > 1100 ) && (cpm <= 1199)) {
        przedzial = '1100-1199';
      } else if ((cpm > 1200 ) && (cpm <= 1299)) {
        przedzial = '1200-1299';
      } else if ((cpm > 1300 ) && (cpm <= 1399)) {
        przedzial = '1300-1399';
      } else if ((cpm > 1400 ) && (cpm <= 1499)) {
        przedzial = '1400-1499';
      } else if ((cpm > 1500 ) && (cpm <= 1599)) {
        przedzial = '1500-1599';
      } else if ((cpm > 1600 ) && (cpm <= 1699)) {
        przedzial = '1600-1699';
      } else if ((cpm > 1700 ) && (cpm <= 1799)) {
        przedzial = '1700-1799';
      } else if ((cpm > 1800 ) && (cpm <= 1899)) {
        przedzial = '1800-1899';
      } else if ((cpm > 1900 ) && (cpm <= 1999)) {
        przedzial = '1900-1999';
      } else if ((cpm > 2000 ) && (cpm <= 2099)) {
        przedzial = '2000-2099';
      } else if ((cpm > 2100 ) && (cpm <= 2199)) {
        przedzial = '2100-2199';
      } else if ((cpm > 2200 ) && (cpm <= 2299)) {
        przedzial = '2200-2299';
      } else if ((cpm > 2300 ) && (cpm <= 2399)) {
        przedzial = '2300-2399';
      } else if ((cpm > 2400 ) && (cpm <= 2499)) {
        przedzial = '2400-2499';
      } else if ((cpm > 2500 ) && (cpm <= 2599)) {
        przedzial = '2500-2599';
      } else if ((cpm > 2600 ) && (cpm <= 2699)) {
        przedzial = '2600-2699';
      } else if ((cpm > 2700 ) && (cpm <= 2799)) {
        przedzial = '2700-2799';
      } else if ((cpm > 2800 ) && (cpm <= 2899)) {
        przedzial = '2800-2899';
      } else if ((cpm > 2900 ) && (cpm <= 2999)) {
        przedzial = '2900-2999';
      } else {
        przedzial = 'kontakt';
        // console.log('CPM POZA ZAKRESEM REKOMENDACJI')
      }
      // console.log('PRZEDZIAŁ REKOMENDACJI:');
      // console.log(przedzial);
      if ((przedzial == 'kontakt') || (nazwa == 'kontakt')) {
        // console.log('KONTAKT');
        // console.log('REKOMENDUJE KONTAKT Z DIETETYKIEM')
        kalorycznosc1 = undefined;
        $('#cta-btn').hide();
        $('#konfigurator-wynik-box').removeClass('active');
        $('#kontakt-info-container').addClass('active');
      } else {
        kalorycznosc1 = $('input[data-cpm="'+przedzial+'"]').attr('data-kalorycznosc-'+cel);
        // console.log(nazwa);
        // console.log(kalorycznosc1);
        $('#rekomendacja-diety').html(kalorycznosc1 + ' kcal');
        $('#cta-btn').show();
        $('#kontakt-info-container').removeClass('active');
        $('#konfigurator-wynik-box').addClass('active');
      }
    }

  },
}
